import React from 'react';
import { Tab, TabList, makeStyles, tokens } from '@fluentui/react-components';
import { ErrorCircleRegular, KeyRegular, PeopleRegular } from '@fluentui/react-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getAdminNavigation } from './sidebarNavigation';

const useStyles = makeStyles({
  navigation: {
    flexShrink: 0,
    padding: '12px 40px 0',
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
  },
  tabs: {
    gap: '8px',
  },
});

const sectionIcons = {
  users: <PeopleRegular />,
  'error-reports': <ErrorCircleRegular />,
  'sign-in-access': <KeyRegular />,
};

const AdminSectionNavigation: React.FC = () => {
  const styles = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const { canImpersonate, canManageErrorReports, canManageSignInAccess } = useAuth();
  const sections = getAdminNavigation(canImpersonate, canManageErrorReports, canManageSignInAccess);

  return (
    <nav className={styles.navigation} aria-label="Admin sections">
      <TabList
        className={styles.tabs}
        selectedValue={location.pathname}
        onTabSelect={(_, data) => navigate(data.value as string)}
      >
        {sections.map((section) => (
          <Tab key={section.key} value={section.path} icon={sectionIcons[section.key]}>
            {section.label}
          </Tab>
        ))}
      </TabList>
    </nav>
  );
};

export default AdminSectionNavigation;